export function prepareBase64File(extension, base64File) {
  const types = {
    JPG: `data:image/jpeg;base64,${base64File}`,
    JPEG: `data:image/jpeg;base64,${base64File}`,
    PDF: `data:application/pdf;base64,${base64File}`,
    PNG: `data:image/png;base64,${base64File}`,
    TIFF: `data:image/tiff;base64,${base64File}`,
    CSV: `data:application/csv;base64,${base64File}`,
    TXT: `data:text/plain;base64,${base64File}`,
    XLSX: `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64File}`,
  };

  if (extension) return types[extension.replaceAll('.', '').toUpperCase()];
  return null;
}

export function downloadFile(base64, filename, extension) {
  const temp = prepareBase64File(extension, base64);

  const download = document.createElement('a');
  download.href = temp;
  download.download = filename;
  document.body.appendChild(download);
  download.click();
  document.body.removeChild(download);
}
